import { useContent } from "contexts/contentContext/contentContext";
import Slider from "../Slider";
import { Dispatch, memo, SetStateAction } from "react";
import SendThanksBtn from "../SendThanksBtn/SendThanksBtn";

import styles from "../thanksActionModals.module.scss";

interface DonationModalI {
  sliderValue: number;
  setSliderValue: Dispatch<SetStateAction<number>>;
  setActiveModal: Dispatch<
    SetStateAction<
      "amount-for-thanks" | "complete-purchase" | "thanks-form-modal"
    >
  >;
}

const DonationModal = memo(
  ({ sliderValue, setSliderValue, setActiveModal }: DonationModalI) => {
    const { getTextByKey } = useContent();

    return (
      <div className={styles.modal}>
        <div className={styles.modalTextWrap}>
          <h5>{getTextByKey("thanks-to-jumomail")}</h5>
          <p>{getTextByKey("jumbo-mail-free-service-text")}</p>
          <p className={styles.description}>
            {getTextByKey("choose-contribution-text")}
          </p>
        </div>
        <Slider value={sliderValue} setValue={setSliderValue} />
        <div className={styles.thanksBtnWrap}>
          <SendThanksBtn
            title={getTextByKey("send-thanks")}
            setActiveModal={setActiveModal}
            sliderValue={sliderValue}
            nextModalId={"complete-purchase"}
          />
        </div>
      </div>
    );
  }
);

export default DonationModal;
